import { z } from "zod"

// Shared between app and iframe

export const DEFAULT_SCHEMA_NS = "https://wistor.nl/ifc/v4#"
export const DEFAULT_INSTANCES_NS = "https://wistor.nl/ifc/v4/inst/"
export const DEFAULT_ENTITIES_PER_ITERATION = 100
export const DEFAULT_BYTES_PER_REQUEST = 10 * 1024 * 1024

export const ifcToLdConfigSchema = z.object({
  namespaces: z.object({
    instances: z.string().nullish(),
    schema: z.string().nullish(),
  }).optional(),
  output: z.object({
    categories: z.array(z.string()).nullish(),
    attributes: z.array(z.string()).nullish(),
    relations: z.array(z.string()).nullish(),
    psetNameRegex: z.string().nullish(),
  }).optional(),
  streaming: z.object({
    minimumEntitiesPerIteration: z.number().nullish(),
    minimumBytesPerRequest: z.number().nullish(),
  }).optional()
})

export const EMPTY_IFC_TO_LD_CONFIG = {
  namespaces: {
    schema: DEFAULT_SCHEMA_NS,
    instances: DEFAULT_INSTANCES_NS,
  },
  output: {
    categories: null,
    attributes: null,
    relations: null,
    psetNameRegex: null
  },
  streaming: {
    minimumEntitiesPerIteration: DEFAULT_ENTITIES_PER_ITERATION,
    minimumBytesPerRequest: DEFAULT_BYTES_PER_REQUEST
  }
} as const satisfies IfcToLdConfig

export type IfcToLdConfig = z.infer<typeof ifcToLdConfigSchema>
